import React from 'react';
import { Box, Grid } from '@mui/material';
import { SkiPass } from '@/types';
import SkiPassCard from '@/components/skipass/SkiPassCard';

interface SkiPassListProps {
  skiPasses: SkiPass[];
  onAdd: (skiPass: Omit<SkiPass, 'id'>) => void;
  onUpdate: (skiPass: SkiPass) => void;
  onDelete: (skiPassId: string) => void;
}

const SkiPassList: React.FC<SkiPassListProps> = ({ skiPasses, onAdd, onUpdate, onDelete }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={3}>
        {skiPasses.map((skiPass) => (
          <Grid size={{ xs: 12, md: 6, lg: 4 }} key={skiPass.id}>
            <SkiPassCard 
              skiPass={skiPass}
              onUpdate={onUpdate}
              onDelete={onDelete}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SkiPassList;
